import PickupOrder from "../models/PickupOrder";
import GhaPickupStatusAwb from '../models/GhaPickupStatusAwb';
import PickupOrderGha from "../models/PickupOrderGha";

const PO_SCHEMA: PickupOrder = {
  additional_info: '',
  bill_to: { full_address: '' },
  create_date: '',
  deliver_to: { full_address: '' },
  delivery_company_name: '',
  dispatch_contact: '',
  driver_checkin_time: '',
  driver_contact: '',
  driver_eta: '',
  driver_eta_timestamp: '',
  driver_last_loc: '',
  driver_id: '',
  driver_id_type: '',
  driver_name: '',
  driver_vehichle_registration: '',
  rfs_number: '',
  endorse_to: { full_address: '' },
  forwarder_company_info: { info: '', address: '', po_prefix: '', contacts: []},
  forwarder_company_name: '',
  gha_info: { tz: '', info: '', address: '', po_support: false },
  id: -1,
  id_delivery_company: -1,
  id_driver: -1,
  id_forwarder: -1,
  id_gha: -1,
  latest_eta: '',
  list: [],
  number: '',
  pickup_date: '',
  pickup_from: { full_address: '' },
  pickup_time: '',
  pickup_time_timestamp: '',
  status: '',
  fully_returned: false,
  trucker_info: '',
  driver_signature_key: '',
  cutoff_date: '',
  cutoff_time: '',
  locked: false,
  sealed: false,
  seal_number: '',
  order_type: '',
  dock_name: '',
  fwd_user_name: '',
  delivered_time: null,
  allowed_ops: {
    update_date: true,
    update_awb_address: true,
    update_dispatch_driver_details: true,
    driver_checked_in: true,
    update_wh_locations: true,
    set_dock: true,
    update_exception_and_notes: true,
    update_customs_clearance: true,
  }
};

const PO_AWB_SCHEMA: GhaPickupStatusAwb ={
  id: -1,
  pieces: 0,
  weight: '',
  remarks: { remarks_text: '' },
  removed: false,
  wh_location: {
    data: [],
    status: 'stored'
  },
  transportation_profile: 'ds',
  transportation_number: '',
  security_notes: '',
  shipper_profile: 'Unknown',
  ccsf_pre_screened: false,
  ccsf_approval_number: '',
  unknown_on_pax_flight: false,
  flight_exception : '',
  r4c_form_ver: -1,
  r4c_form_data: '',
  r4c_form_green: false,
  its: null,
  customs_cleared: false,
  payment_confirmed: false,
  clear_awb: false,
  due: false,
  iacOkay: false,
  ccsfOkay: false,
  id_awb: -1,
  id_pickup_order: -1,
  actual_scale_weight: '',
  ccsf_type: '',
  cwt_data: {
    data: [],
    measurement_unit: ''
  },
  show_on_pod: {
    data: [
      { type: "notes", value: false, label: "Notes" },
      { type: "pictures", value: false, label: "Pictures" },
      { type: "contents_damaged", value: false, label: "Contents Damaged" },
      { type: "kind_of_exception", value: false, label: "Kind of Exception" },
      { type: "type_of_packaging", value: false, label: "Type of Packaging" }
    ]
  },
  info_to_wh: '',
  general_remarks: '',
  iac_name: '',
  ccsf_name: '',
  shipper_name: '',
  interline_transfer_program: {
    carrier: '',
    transfer_programs: []
  },
  customer_error: false
}

const PO_SCHEMA_GHA: PickupOrderGha = {
  additional_info: '',
  bill_to: { full_address: '' },
  create_date: '',
  deliver_to: { full_address: '' },
  delivery_company_name: '',
  dispatch_contact: '',
  driver_checkin_time: '',
  driver_contact: '',
  driver_eta: '',
  driver_eta_timestamp: '',
  driver_last_loc: '',
  driver_name: '',
  driver_vehichle_registration: '',
  rfs_number: '',
  endorse_to: { full_address: '' },
  forwarder_company_info: { info: '', address: '', po_prefix: '', type: '' },
  forwarder_company_name: '',
  gha_info: { tz: '', info: '', address: '', po_support: false },
  id: -1,
  id_delivery_company: -1,
  id_forwarder: -1,
  id_gha: -1,
  latest_eta: '',
  list: [],
  number: '',
  pickup_date: '',
  pickup_from: { full_address: '' },
  pickup_time: '',
  pickup_time_timestamp: '',
  status: '',
  trucker_info: '',
  driver_id: null,
  driver_id_type: null,
  matching_photo: null,
  locked: false,
  sealed: false,
  order_type: 'po',
  seal_number: '',
  iac_number: '',
  valid_transportation: false,
  valid_seal_number: true,
  allowed_ops: {
    update_date: true,
    update_awb_address: true,
    update_dispatch_driver_details: true,
    driver_checked_in: true,
    update_wh_locations: true,
    set_dock: true,
    update_exception_and_notes: true,
    update_customs_clearance: true,
  },
  interline_transfer_program: {
    carrier: '',
    transfer_programs: []
  }
};

export {
  PO_SCHEMA,
  PO_AWB_SCHEMA,
  PO_SCHEMA_GHA
}
